import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectors as orderSelectors, selectorsByType } from 'state/order';
import { isEmpty } from 'utils/types';

const PricingDisclaimer = ({ className }) => {
  const { t } = useTranslation('Quote');
  const orderType = useSelector(orderSelectors.getTypeOfOrder);
  const quote = useSelector(selectorsByType.quote[orderType].getQuote);
  const isQuotingWithZipCode = useSelector(
    orderSelectors.getIsQuotingWithZipCode
  );
  const showVehicleRequirementMessage = quote?.poi_vehicle_requirement_applied;
  const isDataReady = useMemo(() => !isEmpty(quote), [quote]);

  return (
    <>
      {isDataReady && (
        <div className={className} data-testid="data-disclaimer">
          <>
            {isQuotingWithZipCode && (
              <p data-testid="with-zipcode">{t('quote_with_postalCode')}</p>
            )}
            {showVehicleRequirementMessage && (
              <p data-testid="vehicle-requirement">
                {t('quote_vehicle_requirement', {
                  vehicle_type: t(`vehicles.${quote.vehicle_type}`),
                })}
              </p>
            )}
          </>
        </div>
      )}
    </>
  );
};

export default PricingDisclaimer;
